import api from "@/api/axios";

const API_URL = "/student-feedback";

export const getLiveSessions = () => api.get(`${API_URL}/sessions`);
export const getStudentAsyncSessions = () => api.get(`${API_URL}/async-sessions`);
export const getSessionFeedback = (sessionId, teamId) =>
  api.get(`${API_URL}/sessions/${sessionId}/feedback`, {
    params: { team_id: teamId }
  });
export const getUserSession = (sessionId) => api.get(`${API_URL}/sessions/${sessionId}/user-session`);
